import LabeledInput from "components/labeledInput/LabeledTextInput";
import { formikConnect } from "utils/formikConnect";

export default formikConnect(LabeledInput);
